import { useIoContext, useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { useFeatureFlags } from '../useFeatureFlags';
export function useDownloadAgreementPdf() {
    const pdfHost = useStore(selectors.pdfHost);
    const apiGatewayHost = useStore((state)=>state.session.apiGatewayHost);
    const { openNewTab } = useIoContext();
    const { RELATIONSHIP_PDF_SCOUT } = useFeatureFlags();
    return {
        downloadAgreementPdf (relationshipId) {
            const host = RELATIONSHIP_PDF_SCOUT ? apiGatewayHost : pdfHost;
            openNewTab("".concat(host, "/relationship-pdf/").concat(relationshipId));
        }
    };
}
